export const tags = [
  {
    tag: "romance",
    value: false,
  },
  {
    tag: "drama",
    value: false,
  },
  {
    tag: "mystery",
    value: false,
  },
  {
    tag: "comedy",
    value: false,
  },
  {
    tag: "horror",
    value: false,
  },
  {
    tag: "fantasy",
    value: false,
  },
  {
    tag: "adventure",
    value: false,
  },
  {
    tag: "science-fiction",
    value: false,
  },
];

export const sceneConstructor = {
  title: [],
  text: "",
  creatorId: "",
  creatorName: "",
  parents: "",
  children: [],
  tags: [],
  comments: [],
  likes: 0,
};
